module.exports = __webpack_public_path__ + "img/purchase-confirmation.e2a67486.svg";